import * as React from 'react';
import * as actions from './actions/TemplateActions';
import { connect } from 'react-redux';
import {
    Table,
    Button,
    ButtonToolbar,
    FormGroup,
    ControlLabel,
    FormControl
} from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import FormSelect from '../../components/common/FormSelect';
import TemplateModal from './TemplateModal';
import { handleError } from '../../shared/ErrorCatching';

class TemplateListPage extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props, context);

        this.state = {};

        this.closeModal = this.closeModal.bind(this);
        this.save = this.save.bind(this);
        this.edit = this.edit.bind(this);
        this.search = this.search.bind(this);
        this.filterByType = this.filterByType.bind(this);
    }

    componentDidMount() {
        this.props.actions.getTemplates();
    }

    render() {
        let templates = this.props.templates.sort((a, b) => {
            if (a.key.displayName < b.key.displayName) return -1;
            if (a.key.displayName > b.key.displayName) return 1;
            else return 0;
        });
        let searchFilter = this.state.searchFilter;
        if (searchFilter && searchFilter.length > 0) {
            let lowerCaseSearchFilter = searchFilter.toLowerCase();

            templates = templates.filter((template: any) => {
                return template.key.displayName.toLowerCase().indexOf(lowerCaseSearchFilter) > -1;
            });
        }

        let typeFilter = this.state.typeFilter;
        if (typeFilter) {
            templates = templates.filter((template: any) => {
                return template.key.templateType.value.toString() === typeFilter;
            });
        }

        return (
            <div>
                <div className="col-md-3">
                    <FormGroup controlId="search_box">
                        <ControlLabel>{Translate('templates/list/search')}</ControlLabel>
                        <FormControl
                            type="text"
                            name="search"
                            value={this.state.searchFilter ? this.state.searchFilter : ''}
                            onChange={this.search}
                        />
                    </FormGroup>
                </div>
                <div className="col-md-3">
                    <FormGroup controlId="search_filter">
                        <ControlLabel>{Translate('templates/list/filter-type')}</ControlLabel>
                        <FormSelect
                            name="filter"
                            value={this.state.typeFilter}
                            onChange={this.filterByType}
                        >
                            <option value="-1">
                                {Translate('templates/list/filter-type-default-value')}
                            </option>
                            {this.props.templateTypes.map((t: any) => {
                                return (
                                    <option key={t.id} value={t.id}>
                                        {t.name}
                                    </option>
                                );
                            })}
                        </FormSelect>
                    </FormGroup>
                </div>
                <Table hover responsive>
                    <thead>
                        <tr>
                            <th>{Translate('templates/list/headers/name')}</th>
                            <th>{Translate('templates/list/headers/type')}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {templates.map((t) => (
                            <tr key={t.key.displayName}>
                                <td>{t.key.displayName}</td>
                                <td>{t.key.templateType.displayName}</td>
                                <td className="tools">
                                    <ButtonToolbar className="pull-right btn-group-sm">
                                        <Button
                                            onClick={() => this.edit(t.key.value)}
                                            bsStyle="primary"
                                        >
                                            <i className="material-icons">edit</i>{' '}
                                            {Translate('templates/list/row/edit-button')}
                                        </Button>
                                    </ButtonToolbar>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
                {this.state.showModal && (
                    <TemplateModal
                        save={this.save}
                        template={this.props.editModel.templates}
                        files={this.props.editModel.templateFiles}
                        tags={this.props.editModel.tags}
                        close={this.closeModal}
                        site={this.props.site}
                    />
                )}
            </div>
        );
    }

    search(e: any) {
        return this.setState({ searchFilter: e.target.value });
    }

    filterByType(e: any) {
        if (e.target.value === '-1') {
            return this.setState({ typeFilter: undefined });
        }

        return this.setState({ typeFilter: e.target.value });
    }

    edit(key) {
        this.props.actions.editTemplate(key).then(() => {
            this.setState({ showModal: true, currentKey: key });
        });
    }

    closeModal() {
        this.setState({ showModal: false, currentKey: -1 });
    }

    save(templates: any[]) {
        if (this.state.currentKey > 0 && templates.length > 0) {
            this.props.actions
                .update(this.state.currentKey, { templates: templates })
                .then(() => {
                    this.closeModal();
                })
                .catch((error) => handleError(error));
        }
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        templates: state.templates.list.templates,
        templateTypes: state.templates.list.templateTypes,
        editModel: state.templates.edit,
        site: state.site
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            getTemplates: () => dispatch(actions.getTemplates()),
            editTemplate: (key: number) => dispatch(actions.editTemplate(key)),
            update: (key: string, data: any) => dispatch(actions.updateTemplate(key, data))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TemplateListPage);
